var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]},_vm._l((_vm.filteredDiscounts),function(discount){return _c('div',{key:discount.id,staticClass:"c-box u-my-2"},[_c('div',{domProps:{"innerHTML":_vm._s(discount.content)}})])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1586bf0c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TourPriceDiscounts.vue
// module id = 493
// module chunks = 0